/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Schema para los datos de entrada al crear un usuario desde el panel de admin.
 */
export interface UserCreateRequest { 
    email: string;
    name: string;
    firstSurname: string;
    nif?: string | null;
    secondSurname?: string | null;
    telephone?: string | null;
    countryIsoCode?: string;
    useAlternativeIdentifier?: boolean;
}

